__turbopack_context__.v({
  "caption": "styles-module-scss-module__a6IYCW__caption",
  "currencyDescr": "styles-module-scss-module__a6IYCW__currencyDescr",
  "description": "styles-module-scss-module__a6IYCW__description",
  "icon": "styles-module-scss-module__a6IYCW__icon",
  "list": "styles-module-scss-module__a6IYCW__list",
  "listItem": "styles-module-scss-module__a6IYCW__listItem",
  "listItemIcon": "styles-module-scss-module__a6IYCW__listItemIcon",
  "pulszAmount": "styles-module-scss-module__a6IYCW__pulszAmount",
  "pulszIcon": "styles-module-scss-module__a6IYCW__pulszIcon",
  "pulszList": "styles-module-scss-module__a6IYCW__pulszList",
  "pulszListItem": "styles-module-scss-module__a6IYCW__pulszListItem",
  "pulszRewardContent": "styles-module-scss-module__a6IYCW__pulszRewardContent",
  "pulszRoot": "styles-module-scss-module__a6IYCW__pulszRoot",
  "pulszSubtitle": "styles-module-scss-module__a6IYCW__pulszSubtitle",
  "pulszTitle": "styles-module-scss-module__a6IYCW__pulszTitle",
  "root": "styles-module-scss-module__a6IYCW__root",
  "title": "styles-module-scss-module__a6IYCW__title",
});
